<script>
export default {
  data(){
    return {
      statesList: [
        { label: "Wilayah Persekutuan", value: "Wilayah Persekutuan" },
        { label: "Kelantan", value: "Kelantan" },
        { label: "Johor", value: "Johor" },
        { label: "Kedah", value: "Kedah" },
        { label: "Melaka", value: "Melaka" },
        { label: "Negeri Sembilan", value: "Negeri Sembilan" },
        { label: "Pahang", value: "Pahang" },
        { label: "Penang", value: "Penang" },
        { label: "Perak", value: "Perak" },
        { label: "Perlis", value: "Perlis" },
        { label: "Sabah", value: "Sabah" },
        { label: "Sarawak", value: "Sarawak" },
        { label: "Selangor", value: "Selangor" },
        { label: "Terengganu", value: "Terengganu" }
      ],
      bankList: [
        {label: "AFFIN BANK BERHAD", value: "AFFIN BANK BERHAD"},
        {label: "AL RAJHI BANKING AND INVESTMENT CORPORATION (MALAYSIA) BHD", value: "AL RAJHI BANKING AND INVESTMENT CORPORATION (MALAYSIA) BHD"},
        {label: "ALLIANCE BANK MALAYSIA BERHAD", value: "ALLIANCE BANK MALAYSIA BERHAD"},
        {label: "AMBANK (M) BERHAD", value: "AMBANK (M) BERHAD"},
        {label: "BANGKOK BANK BERHAD", value: "BANGKOK BANK BERHAD"},
        {label: "BANK ISLAM MALAYSIA BERHAD", value: "BANK ISLAM MALAYSIA BERHAD"},
        {label: "BANK KERJASAMA RAKYAT MALAYSIA BERHAD", value: "BANK KERJASAMA RAKYAT MALAYSIA BERHAD"},
        {label: "BANK MUAMALAT MALAYSIA BERHAD", value: "BANK MUAMALAT MALAYSIA BERHAD"},
        {label: "BANK OF AMERICA (MALAYSIA) BERHAD", value: "BANK OF AMERICA (MALAYSIA) BERHAD"},
        {label: "BANK OF CHINA (MALAYSIA) BERHAD", value: "BANK OF CHINA (MALAYSIA) BERHAD"},
        {label: "BANK OF TOKYO-MITSUBISHI UFJ (MALAYSIA) BERHAD", value: "BANK OF TOKYO-MITSUBISHI UFJ (MALAYSIA) BERHAD"},
        {label: "BANK PERTANIAN MALAYSIA BHD (AGROBANK)", value: "BANK PERTANIAN MALAYSIA BHD (AGROBANK)"},
        {label: "BANK SIMPANAN NASIONAL BERHAD", value: "BANK SIMPANAN NASIONAL BERHAD"},
        {label: "BNP PARIBAS MALAYSIA BERHAD", value: "BNP PARIBAS MALAYSIA BERHAD"},
        {label: "CIMB BANK BERHAD", value: "CIMB BANK BERHAD"},
        {label: "CITIBANK BERHAD", value: "CITIBANK BERHAD"},
        {label: "DEUTSCHE BANK (MALAYSIA) BERHAD", value: "DEUTSCHE BANK (MALAYSIA) BERHAD"},
        {label: "HONG LEONG BANK BERHAD", value: "HONG LEONG BANK BERHAD"},
        {label: "HSBC BANK MALAYSIA BERHAD", value: "HSBC BANK MALAYSIA BERHAD"},
        {label: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA", value: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA"},        
        {label: "J.P.MORGAN CHASE BANK BERHAD", value: "J.P.MORGAN CHASE BANK BERHAD"},
        {label: "KUWAIT FINANCE HOUSE (MALAYSIA) BERHAD", value: "KUWAIT FINANCE HOUSE (MALAYSIA) BERHAD"},
        {label: "MALAYAN BANKING BERHAD (MAYBANK)", value: "MALAYAN BANKING BERHAD (MAYBANK)"},
        {label: "MBSB BANK BERHAD", value: "MBSB BANK BERHAD"},
        {label: "MIZUHO CORPORATE BANK (MALAYSIA) BERHAD", value: "MIZUHO CORPORATE BANK (MALAYSIA) BERHAD"},
        {label: "OCBC AL-AMIN BANK BERHAD", value: "OCBC AL-AMIN BANK BERHAD"},
        {label: "OCBC BANK (MALAYSIA) BERHAD", value: "OCBC BANK (MALAYSIA) BERHAD"},
        {label: "PUBLIC BANK BERHAD", value: "PUBLIC BANK BERHAD"},
        {label: "RHB BANK BERHAD", value: "RHB BANK BERHAD"},
        {label: "STANDARD CHARTERED BANK MALAYSIA BERHAD", value: "STANDARD CHARTERED BANK MALAYSIA BERHAD"},
        {label: "SUMITOMO MITSUI BANKING CORPORATION", value: "SUMITOMO MITSUI BANKING CORPORATION"},
        {label: "UNITED OVERSEAS BANK (MALAYSIA) BERHAD", value: "UNITED OVERSEAS BANK (MALAYSIA) BERHAD"},
      ]
    }
  },
  methods: {
    dateTimeFormatter(dateTime) {
      return [this.dateFormatter(dateTime), this.timeFormatter(dateTime)];
    },
    dateFormatter(dateTime) {            
      let formattedDate =
        this.dateTimeFormatterAppendLeadingZero(dateTime.getDate()) +
        "-" +
        this.dateTimeFormatterAppendLeadingZero(dateTime.getMonth()+1) +
        "-" +
        dateTime.getFullYear();
      return formattedDate;
    },
    timeFormatter(dateTime) {
      let twelveHourFormat;
      let hours = this.dateTimeFormatterAppendLeadingZero(dateTime.getHours());
      if (hours >= 0 && hours <= 12) {
        twelveHourFormat = "AM";
      } else if ((hours > 12 && hours <= 23) || hours == 0) {
        hours = hours - 12;
        twelveHourFormat = "PM";
      }
      let formattedTime =
        hours +
        ":" +
        this.dateTimeFormatterAppendLeadingZero(dateTime.getMinutes()) +
        ":" +
        this.dateTimeFormatterAppendLeadingZero(dateTime.getSeconds()) +
        twelveHourFormat;
      return formattedTime;
    },

    dateTimeFormatterAppendLeadingZero(val) {
      if (val < 10) {
        return "0" + val;
      }
      return val;
    },
    showReloadWallet(val) {
      this.$store.commit("TOGGLE_RELOAD_WALLET_POPUP", val);
    },
    redirectToRoute(route) {
      this.$router.push(route);
    },
    getStateName(stateCode){
      for(let i=0; i<this.statesList.length; i++){
        if(this.statesList[i].value == stateCode){
          return this.statesList[i].text;          
        }
      }
    }
  }
};
</script>
